import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import { TextInput } from 'react-admin';
import { useFormContext } from 'react-hook-form';

import { slugify } from './utils';

import SlugInput from './SlugInput';

const TitleSlug = ({
    isCreate,
    isSlugHidden,
    pageUrlPart,
    slugLabel,
    source,
    titleLabel = 'Title',
    required,
}) => {
    const { setValue } = useFormContext();

    const handleOnChange = useCallback((e) => {
        if (!isCreate || !setValue) {
            return;
        }

        setValue(source.slug, slugify(e.nativeEvent.target.value));
    }, [isCreate, setValue, source.slug]);

    if (isSlugHidden) {
        return (
            <Grid container sx={{ width: '100%' }}>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <TextInput
                        fullWidth
                        label={titleLabel}
                        source={source.title}
                        required={required}
                        onChange={handleOnChange}
                    />
                    <TextInput
                        source={source.slug}
                        sx={{ display: 'none' }}
                    />
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            <Grid container className="title-slug-container" sx={{ width: '100%' }}>
                <Grid
                    className="title-slug-title" size={{ xs: 12, sm: 12, md: 12 }}
                >
                    <TextInput
                        fullWidth
                        label={titleLabel}
                        required={required}
                        source={source.title}
                        onInput={handleOnChange}
                    />
                </Grid>
            </Grid>
            <Grid container sx={{ width: '100%' }}>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                    <SlugInput
                        fullWidth
                        label={slugLabel || 'URL'}
                        required={required}
                        source={source.slug}
                        pageUrlPart={pageUrlPart}
                        options={{ fullWidth: true }}
                    />
                </Grid>
            </Grid>
        </>
    );
};

TitleSlug.propTypes = {
    isCreate: PropTypes.bool,
    isSlugHidden: PropTypes.bool,
    pageUrlPart: PropTypes.string.isRequired,
    source: PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
    }).isRequired,
    titleLabel: PropTypes.string,
    slugLabel: PropTypes.string,
    required: PropTypes.bool,
};

export default TitleSlug;
